import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideRoutes, RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { IconsRegistry } from '@p1/libs/icons/src/lib/registry/icons.registry';
import {
  iconArrowLeft,
  iconLock,
  iconWatchlistAdd
} from '@p1/libs/icons/src/lib/registry/icons';
import { illustrationEmptyWatchlistSnapshot } from '@p1/libs/icons/src/lib/registry/illustrations';

import { WatchlistsSharedModule } from '../watchlists/watchlists.shared.module';
import { SharedModule } from '../shared/shared.module';
import { watchlistSnapshotsRoutes } from './watchlist-snapshots.routes';
import { WatchlistSnapshotDetailPageComponent } from './page-detail/watchlist-snapshot-detail-page.component';
import { WatchlistSnapshotsStoreModule } from './watchlist-snapshots.store.module';
import { WatchlistSnapshotDetailPageGuard } from './page-detail/guard/watchlist-snapshot-detail-page.guard';
import { EmptyWatchlistSnapshotTeaserComponent } from './page-detail/empty-teaser/empty-watchlist-snapshot-teaser.component';
import { MyWatchlistsStoreModule } from '../my-watchlists/my-watchlists.store.module';
import { CopyWatchlistDialogComponent } from './page-detail/copy-watchlist-dialog/copy-watchlist-dialog.component';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    WatchlistsSharedModule,
    WatchlistSnapshotsStoreModule,
    MyWatchlistsStoreModule,
    RouterModule.forChild(watchlistSnapshotsRoutes)
  ],
  declarations: [
    CopyWatchlistDialogComponent,
    EmptyWatchlistSnapshotTeaserComponent,
    WatchlistSnapshotDetailPageComponent
  ],
  providers: [
    WatchlistSnapshotDetailPageGuard,
    provideRoutes([
      {
        loadChildren: () => import('../my-watchlists/my-watchlists.store.module').then(m => m.MyWatchlistsStoreModule)
      }
    ])
  ]
})
export class WatchlistSnapshotsModule {
  constructor(private _iconsRegistry: IconsRegistry) {
    this._iconsRegistry.registerIcons([
      iconArrowLeft,
      iconLock,
      iconWatchlistAdd,
      illustrationEmptyWatchlistSnapshot
    ]);
  }
}
